<template>
  <div>
    <div class="videoDetails__head">
      <video src="http://vd4.bdstatic.com/mda-jjw5psqpaq504uvn/sc/mda-jjw5psqpaq504uvn.mp4" controls></video>
      <div class="flex videoDetails__head_row">
        <div>全身理疗技法</div>
        <div class="col_666 flex_center articleList__browse"><span class="iconfont icon-liulan"></span><span>2343</span></div>
      </div>
    </div>
    <div class="videoDetails__content">
      <p class="fs_15 col_333">视频介绍</p>
      <div class=""> 按摩是以中医的脏腑、经络学说为理论基础，并结合西医的解剖和病理诊断，而用手法作用于人体体表的特定部位以调节机体生理、病理状况，达到理疗目的的方法，从性质上来说，它是一种物理的治疗方法。从按摩的治疗上，可分为保健按摩、运动按摩和医疗按摩。</div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "videoDetails"
    }
</script>

<style scoped>
  .videoDetails__head{
    background: #fff;
    margin-bottom: .5rem;
  }
  .videoDetails__head_row{
    padding: 0 .75rem;
    font-size: .75rem;
    color: #333;
    min-height: 2.2rem;
  }
  .articleList__browse{
    justify-content: end;
    -webkit-justify-content: flex-end;
    font-size: .6rem;
    height: .6rem;
    line-height: .6rem;
  }
  .videoDetails__content{
    background: #fff;
    padding: 0 .75rem .5rem;
    color: #666;
    font-size: .6rem;
  }
  .videoDetails__content>p{
    line-height: 2.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/message/videoDetails.vue